import XLSX from "sheetjs-style";
import dayjs from "dayjs";
import FileSaver from "file-saver";

export const getExcelData = (columns: any, data: any) => {
	const dataExcel: any[] = [];

	for (const d of data) {
		const row: string[] = [];
		for (const c of columns) {
			if (!["actions"].includes(c.id) && !c.dontExport) {
				const id = typeof c.accessor === "string" ? c.accessor : c.id;

				let value = "";

				// Use exportAccessor if available, otherwise use regular accessor
				if (c.exportAccessor && typeof c.exportAccessor === "function") {
					value = c.exportAccessor(d._original || d);
				} else if (typeof c.accessor === "function") {
					value = c.accessor(d._original || d);
				} else {
					value = d[id];
				}

				if (typeof value === "object" || c.format) {
					value = c.format
						? c.format(d._original || d)
						: (d._original || d)[id];
				}

				row.push(value);
			}
		}
		dataExcel.push(row);
	}

	return [
		{
			columns: columns
				.filter(
					(c: any) => !["actions", "checkbox"].includes(c.id) && !c.dontExport
				)
				.map((c: any) => c.Header || c.id),
			data: dataExcel
		}
	];
};

export const exportToExcel = (columns: any, data: any, title: string) => {
	const dataSet = getExcelData(columns, data);

	console.log("dataSet", dataSet);

	if (dataSet) {
		const wb = XLSX.utils.book_new();

		const ws = XLSX.utils.aoa_to_sheet([
			[title, dayjs().format("DD/MM/YYYY HH:mm:ss")]
		]);

		XLSX.utils.book_append_sheet(wb, ws, "Relatório");

		for (const d of dataSet) {
			const ws = XLSX.utils.aoa_to_sheet([d.columns, ...d.data]);
			XLSX.utils.book_append_sheet(wb, ws, "Dados");
		}

		const wbout = XLSX.write(wb, {
			bookType: "xlsx",
			type: "binary"
		});

		const s2ab = (s: any) => {
			const buf = new ArrayBuffer(s.length);
			const view = new Uint8Array(buf);
			for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
			return buf;
		};

		const blob = new Blob([s2ab(wbout)], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
		});

		FileSaver.saveAs(
			blob,
			title + "_" + dayjs().format("YYYY-MM-DD-HH-mm-ss") + ".xlsx"
		);
	}
};

export const exportExcel = async (
	table: any,
	columns: any[],
	title: string
) => {
	const resolvedState = table.current.getResolvedState();

	const data = table.current.getSortedData(resolvedState).sortedData;

	const { pages, pageSize, onFetchData, resolveData, manual } = resolvedState;

	const callback = (err: any, data: any) => {
		if (err) alert(err);
		else {
			exportToExcel(columns, data, title);
		}
	};

	if (manual) {
		const data2: any[] = [];
		const exportPageSize = 1000;
		let currentPage = 0;
		let hasMoreData = true;

		while (hasMoreData) {
			hasMoreData = await new Promise(resolve => {
				onFetchData({
					...resolvedState,
					page: currentPage,
					pageSize: exportPageSize,
					toExport: true,
					callback: (err, d) => {
						if (err) {
							console.error("Export error:", err);
							resolve(false);
							return;
						}

						const newData = resolveData(d || []);
						data2.push(...newData);

						// Continue if we got a full page of data
						// Stop if we got less than a full page (last page)
						resolve(newData.length === exportPageSize);
					}
				});
			});

			currentPage++;
		}

		callback(null, data2);
	} else {
		callback(null, data);
	}
};
